// ============================================================
// auto-reload.ts  — 自動更新モジュール
// ============================================================

// ローカル名で定義 → window に公開（global.d.ts の declare var AutoReload と衝突しない）
const _autoReloadModule = (function () {
    let _intervalId: ReturnType<typeof setInterval> | null = null;
    let _refreshFn: (() => void) | null = null;
    let _currentSeconds = 0;
    // pause() で一時停止された秒数を覚えておき、resume() で復帰させる
    let _pausedSeconds: number | null = null;

    function getReloadSeconds(): number {
        const val = getParam('reload');
        if (!val) {
            return 0;
        }

        const seconds = parseInt(val, 10);
        if (isNaN(seconds) || seconds <= 0) {
            return 0;
        }

        return Math.max(seconds, 15);
    }

    function setReloadParam(seconds: number): void {
        const url = new URL(window.location.href);
        if (seconds > 0) {
            url.searchParams.set('reload', String(seconds));
        } else {
            url.searchParams.delete('reload');
        }
        window.history.replaceState({}, '', url.toString());
    }

    function updateLastReloadTime(): void {
        const el = document.getElementById('autoReloadLastTime');
        if (el) {
            el.textContent = dayjs().format('HH:mm:ss');
        }
    }

    function getLabel(s: number): string {
        if (s === 0) {
            return '無効';
        }

        return s < 60 ? `${s}秒` : `${s / 60}分`;
    }

    function updateUI(): void {
        document.querySelectorAll<HTMLElement>('.auto-reload-option').forEach((item) => {
            const val = parseInt(item.getAttribute('data-reload-seconds') ?? '0', 10);
            item.classList.toggle('active', val === _currentSeconds);
        });

        const label = document.getElementById('autoReloadLabel');
        if (!label) {
            return;
        }

        Array.from(label.classList)
            .filter((className) => className.startsWith('ar-progress-'))
            .forEach((className) => label.classList.remove(className));

        if (_currentSeconds === 0) {
            label.innerHTML = '<i class="fa-solid fa-clock"></i> 自動更新: 無効';
            label.classList.remove('btn-success');
            label.classList.add('btn-outline-light');
        } else {
            label.innerHTML =
                `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="none" class="ar-icon">` +
                `<circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="2" opacity="0.35"/>` +
                `<circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="2" class="ar-progress-ring"/>` +
                `</svg> 自動更新: ${getLabel(_currentSeconds)}`;
            label.classList.remove('btn-outline-light');
            label.classList.add('btn-success', `ar-progress-${_currentSeconds}`);
        }
    }

    function start(seconds: number): void {
        stop();
        _currentSeconds = seconds;

        if (seconds > 0 && _refreshFn) {
            _intervalId = setInterval(() => {
                _refreshFn!();
                updateLastReloadTime();
                updateUI();
            }, seconds * 1000);
        }

        updateUI();
    }

    function stop(): void {
        if (_intervalId != null) {
            clearInterval(_intervalId);
            _intervalId = null;
        }
    }

    return {
        updateLastReloadTime,
        pause(): void {
            // 走っているときのみ pause を有効化する。
            // _currentSeconds は変えず、見た目（ラベル/プログレスリング）はそのまま、
            // 内部のタイマーだけを停止することでユーザーの設定値を保持する。
            if (_pausedSeconds === null && _intervalId != null) {
                _pausedSeconds = _currentSeconds;
                clearInterval(_intervalId);
                _intervalId = null;
            }
        },
        resume(): void {
            if (_pausedSeconds !== null) {
                const saved = _pausedSeconds;
                _pausedSeconds = null;
                // ユーザーが pause 中に設定を変更した場合 (_currentSeconds が変わった)
                // は変更後の値が既に start() で反映済みなので何もしない
                if (_intervalId == null && _currentSeconds === saved && saved > 0 && _refreshFn) {
                    _intervalId = setInterval(() => {
                        _refreshFn!();
                        updateLastReloadTime();
                        updateUI();
                    }, saved * 1000);
                }
            }
        },
        init(refreshFn: () => void): void {
            _refreshFn = refreshFn;
            _currentSeconds = getReloadSeconds();
            updateLastReloadTime();
            updateUI();

            if (_currentSeconds > 0) {
                start(_currentSeconds);
            }

            $(document).on('click', '.auto-reload-option', function (e) {
                e.preventDefault();

                let s = parseInt($(this).attr('data-reload-seconds') ?? '0', 10);
                s = s > 0 ? Math.max(s, 15) : 0;
                setReloadParam(s);
                start(s);
            });
        },
    };
})();

(window as any).AutoReload = _autoReloadModule;
